// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bef_a bhr_rj bhr_rk bhr_vh bhr_eb bhr_vf bhr_gs bhr_kh"};